import {
  AIDE_MATERIELLE_PROPORTIONNELLE,
  REGIME_BIEN_LEGAL,
} from './casConventionCodes';

const DEFAULT_PACS: any = {
  // Différents ids
  identifiant: null,
  identifiantAdresseCommune: null,
  identifiantLieuConvention: null,
  identifiantLieuDeclaration: null,
  identifiantLieuDissolution: null,
  identifiantLieuPacs: null,
  identifiantTribunal: null,
  // Reste d'un PACS
  numero: null,
  statut: null,
  identifiantEntite: null,
  filiationInconnueMerePartenaire1: null,
  filiationInconnuePerePartenaire1: null,
  filiationInconnueMerePartenaire2: null,
  filiationInconnuePerePartenaire2: null,
  // Registre
  registre: {
    identifiant: null,
    annee: {
      identifiant: null,
      annee: null,
    },
    libelle: null,
    numero: null,
    numeroOrdre: null,
    type: null,
    numerotationManuelle: null,
  },
  conventionDeclaration: {
    annule: null,
    conforme: 1,
    numerise: null,
    partenaire1DateDeces: null,
    partenaire2DateDeces: null,
    dateEnregistrement: null,
    dateDeclarationUnitDi: null,
    dateDeclarationJointDi: null,
    dateDissolution: null,
    identifiantTypeDissolution: null,
    dateSignification: null,
    dateMariage: null,
    typeComparution: 1,
    // Declaration
    dateDeclaration: null,
    attestationLienParente: null,
    attestationAdresseCommune: null,
    // Convention
    typeConvention: 1,
    dateConvention: null,
    // Valeurs par défaut alignées sur ETCV
    aideMaterielle: AIDE_MATERIELLE_PROPORTIONNELLE,
    valeurAide: null,
    regimeBien: REGIME_BIEN_LEGAL,
    // Irrecevabilité
    dateIrrecevabilite: null,
    identifiantIrrecevabilite: null,
    // Officier d'état civil
    signataireNomFamille: null,
    signatairePrenom: null,
    signataireQualite: null,
    commentaire: null,
    // Partenaires
    partenaire1: {
      identifiant: null,
      sexe: null,
      sexeCode: null,
      nomUsage: null,
      nomFamille: null,
      doubleNom: null,
      nomPartieUn: null,
      nomPartieDeux: null,
      prenom: null,
      prenomsComplementaires: null,
      premiereNationalite: null,
      deuxiemeNationalite: null,
      troisiemeNationalite: null,
      // Naissance
      jourNaissance: null,
      moisNaissance: null,
      anneeNaissance: null,
      naissanceLibelleVoie: null,
      naissanceLettre: null,
      adresseNaissance: {
        libelleCodePostal: '83190',
        libelleCommune: 'Ollioules',
        libellePays: 'France',
        libelleDepartement: 'Var',
        codeDepartement: '83',
        naissanceLibelleCommuneDelegue: null,
        naissanceCommuneDelegue: null,
      },
      // Contacts
      tel1: null,
      tel2: null,
      mail: null,
      // Adresse Résidence
      adresseResidence: {
        libelleCodePostal: null,
        libelleCommune: null,
        libellePays: null,
        libelleDepartement: null,
        codeDepartement: null,
        libelleVoie: null,
        indiceRepetition: null,
        complementDistribution: null,
        numeroVoirie: null,
        complementNumeroVoirie: null,
        complementIdentification: null,
        complementGeographique: null,
        residenceLibelleCommuneDelegue: null,
        residenceCommuneDelegue: null,
        typeVoie: null,
        article: null,
      },
      // Informations complémentaires
      protectionOfpra: null,
      identiteVerifiee: null,
      protectionJuridique: null,
    },
    partenaire2: {
      identifiant: null,
      sexe: null,
      sexeCode: null,
      nomUsage: null,
      nomFamille: null,
      doubleNom: null,
      nomPartieUn: null,
      nomPartieDeux: null,
      prenom: null,
      prenomsComplementaires: null,
      premiereNationalite: null,
      deuxiemeNationalite: null,
      troisiemeNationalite: null,
      // Naissance
      jourNaissance: null,
      moisNaissance: null,
      anneeNaissance: null,
      naissanceLibelleVoie: null,
      naissanceLettre: null,
      adresseNaissance: {
        libelleCodePostal: null,
        libelleCommune: null,
        libellePays: null,
        libelleDepartement: null,
        codeDepartement: null,
        naissanceLibelleCommuneDelegue: null,
        naissanceCommuneDelegue: null,
      },
      // Contacts
      tel1: null,
      tel2: null,
      mail: null,
      // Adresse Résidence
      adresseResidence: {
        libelleCodePostal: null,
        libelleCommune: null,
        libellePays: null,
        libelleDepartement: null,
        codeDepartement: null,
        libelleVoie: null,
        indiceRepetition: null,
        complementDistribution: null,
        numeroVoirie: null,
        complementNumeroVoirie: null,
        complementIdentification: null,
        complementGeographique: null,
        residenceLibelleCommuneDelegue: null,
        residenceCommuneDelegue: null,
        typeVoie: null,
        article: null,
      },
      // Informations complémentaires
      protectionOfpra: null,
      identiteVerifiee: null,
      protectionJuridique: null,
    },
    perePartenaire1: {
      identifiant: null,
      sexe: null,
      sexeCode: null,
      nomUsage: null,
      nomFamille: null,
      doubleNom: null,
      nomPartieUn: null,
      nomPartieDeux: null,
      prenom: null,
      prenomsComplementaires: null,
      jourNaissance: null,
      moisNaissance: null,
      anneeNaissance: null,
      adresseNaissance: {
        libelleCodePostal: null,
        libelleCommune: null,
        libellePays: null,
        libelleDepartement: null,
        codeDepartement: null,
        naissanceCommuneDelegue: null,
        naissanceLibelleCommuneDelegue: null,
      },
    },
    merePartenaire1: {
      identifiant: null,
      sexe: null,
      sexeCode: null,
      nomUsage: null,
      nomFamille: null,
      doubleNom: null,
      nomPartieUn: null,
      nomPartieDeux: null,
      prenom: null,
      prenomsComplementaires: null,
      jourNaissance: null,
      moisNaissance: null,
      anneeNaissance: null,
      adresseNaissance: {
        libelleCodePostal: null,
        libelleCommune: null,
        libellePays: null,
        libelleDepartement: null,
        codeDepartement: null,
        naissanceCommuneDelegue: null,
        naissanceLibelleCommuneDelegue: null,
      },
    },
    perePartenaire2: {
      identifiant: null,
      sexe: null,
      sexeCode: null,
      nomUsage: null,
      nomFamille: null,
      prenom: null,
      prenomsComplementaires: null,
      jourNaissance: null,
      moisNaissance: null,
      anneeNaissance: null,
      adresseNaissance: {
        libelleCodePostal: null,
        libelleCommune: null,
        libellePays: null,
        libelleDepartement: null,
        codeDepartement: null,
        naissanceCommuneDelegue: null,
        naissanceLibelleCommuneDelegue: null,
      },
    },
    merePartenaire2: {
      identifiant: null,
      sexe: null,
      sexeCode: null,
      nomUsage: null,
      nomFamille: null,
      prenom: null,
      prenomsComplementaires: null,
      jourNaissance: null,
      moisNaissance: null,
      anneeNaissance: null,
      adresseNaissance: {
        libelleCodePostal: null,
        libelleCommune: null,
        libellePays: null,
        libelleDepartement: null,
        codeDepartement: null,
        naissanceCommuneDelegue: null,
        naissanceLibelleCommuneDelegue: null,
      },
    },
    // Adresses
    adresseConvention: {
      libellePays: null,
      libelleDepartement: null,
      codeDepartement: null,
      codePostal: null,
      libelleCommune: null,
      complementDistribution: null,
      numeroVoie: null,
      lettre: null,
      localite: null,
      complementNumeroVoie: null,
      complementIdentification: null,
      complementGeographique: null,
      libelleVoie: null,
      communeDelegue: null,
      libelleCommuneDelegue: null,
      // Rattachement au référentiel transverse
      identifiantVoie: null,
      identifiantTypeVoie: null,
      typeVoie: null,
      lieuDit: null,
      identifiantCommune: null,
      identifiantCodePostal: null,
      identifiantDepartement: null,
    },
    adresseDeclaration: {
      libellePays: null,
      libelleDepartement: null,
      codeDepartement: null,
      codePostal: null,
      libelleCommune: null,
      complementDistribution: null,
      numeroVoie: null,
      lettre: null,
      localite: null,
      complementNumeroVoie: null,
      complementIdentification: null,
      complementGeographique: null,
      libelleVoie: null,
      communeDelegue: null,
      libelleCommuneDelegue: null,
      // Rattachement au référentiel transverse
      identifiantVoie: null,
      identifiantTypeVoie: null,
      typeVoie: null,
      lieuDit: null,
      identifiantCommune: null,
      identifiantCodePostal: null,
      identifiantDepartement: null,
    },
    adresseDissolution: {
      codePostal: null,
      libelleCommuneDelegue: null,
      articleLocalite: null,
      localite: null,
      communeDelegue: null,
      codeDepartement: null,
      libelleDepartement: null,
      // Rattachement au référentiel transverse
      identifiantVoie: null,
      identifiantTypeVoie: null,
      typeVoie: null,
      lieuDit: null,
      identifiantCommune: null,
      identifiantCodePostal: null,
      identifiantDepartement: null,
    },
    adressePacs: {
      codePostal: null,
      libelleCommuneDelegue: null,
      articleLocalite: null,
      localite: null,
      communeDelegue: null,
      codeDepartement: null,
      libelleDepartement: null,
      // Rattachement au référentiel transverse
      identifiantVoie: null,
      identifiantTypeVoie: null,
      typeVoie: null,
      lieuDit: null,
      identifiantCommune: null,
      identifiantCodePostal: null,
      identifiantDepartement: null,
    },
    adresseCommune: {
      libellePays: null,
      libelleDepartement: null,
      codeDepartement: null,
      codePostal: null,
      libelleCommune: null,
      complementDistribution: null,
      numeroVoie: null,
      lettre: null,
      localite: null,
      complementNumeroVoie: null,
      complementIdentification: null,
      complementGeographique: null,
      libelleVoie: null,
      communeDelegue: null,
      libelleCommuneDelegue: null,
      // Rattachement au référentiel transverse
      identifiantVoie: null,
      identifiantTypeVoie: null,
      typeVoie: null,
      lieuDit: null,
      identifiantCommune: null,
      identifiantCodePostal: null,
      identifiantDepartement: null,
    },
  },
  complementInsee: {
    identifiant: null,
    identifiantPacs: null,
    identifiantEntite: null,
    p1EtatMatrimonialCode: null,
    p1EtatMatrimonialLibelle: null,
    p1DateVeuvage: null,
    p1DateDivorce: null,
    p1DejaPacse: null,
    p2EtatMatrimonialCode: null,
    p2EtatMatrimonialLibelle: null,
    p2DateVeuvage: null,
    p2DateDivorce: null,
    p2DejaPacse: null,
    enfant: null,
    nombreEnfants: null,
    nombreEnfantsDissolution: null,
    enfantDissolution: null,
  },
};

export default DEFAULT_PACS;
